<template>
  <div v-if="errorMessage">
    <p>{{ errorMessage }}</p>
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import { ErrorType } from "@/flows/useCases/imbpBooking/imbpBookingFlowHelper"

  export default defineComponent({
    props: {
      error: {
        type: String as PropType<ErrorType | null>,
        default: null,
      },
    },
    computed: {
      errorMessage() {
        switch (this?.error) {
          case "exchange":
            return "This site already has a SMETS2 smart meter. Please contact a Senior CCA, TL, or a Metering Specialist to book a smart meter installation appointment at this site"
          case "repair":
            return "Please contact a Senior CCA, TL, or a Metering Specialist to book a smart meter investigation  or repair appointment at this site."
          case "emergency":
            return "Please contact a Metering Specialist or Emergency Agent to book an emergency appointment at this site."
          default:
            return "You do not have the right permissions to create this booking. Please contact a Metering Specialist to book an appointment."
        }
      },
    },
  })
</script>
